module.exports = __webpack_public_path__ + "static/img/1.c553402.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/03/1.png
// module id = eKXl
// module chunks = 1